import { MetricsMap } from './metricsUtils';
import { convertHashToCdnUrl } from './creativesFormattingUtils';

const MULTI_VALUED_DIMENSIONS_PATH = 'multiValuedDimensions';
const FILE_NAME_PREFIX = 'Creative Gallery';
const DATE_FORMAT_REGEX = /^\d+-\d+$/;
const UNKNOWN = 'N/A';

const CsvDimensionsMap = {
    IMAGE_HASH: {
        value: 'imageHash',
        label: 'Singular Media ID',
    },
    TYPE: {
        value: 'type',
        label: 'Creative Type',
    },
    VIDEO_DURATION: {
        value: `${MULTI_VALUED_DIMENSIONS_PATH}.creativeVideoDurationList`,
        label: 'Creative Video Duration',
    },
    OS: {
        value: `${MULTI_VALUED_DIMENSIONS_PATH}.osList`,
        label: 'OS',
    },
    ASSET_ID: {
        value: `${MULTI_VALUED_DIMENSIONS_PATH}.assetIdList`,
        label: 'Asset ID',
    },
    ASSET_NAME: {
        value: `${MULTI_VALUED_DIMENSIONS_PATH}.assetNameList`,
        label: 'Asset Name',
    },
    CREATIVE_ID: {
        value: `${MULTI_VALUED_DIMENSIONS_PATH}.creativeIdList`,
        label: 'Creative ID',
    },
    CREATIVE_NAME: {
        value: `${MULTI_VALUED_DIMENSIONS_PATH}.creativeNameList`,
        label: 'Creative Name',
    },
};

const buildFileName = (app, source, dateRange) =>
    `${FILE_NAME_PREFIX}-${app}-${source}-${dateRange.startDate}-${dateRange.endDate}.csv`;

const arrayCsvValue = value => `"${value?.join(', ')}"`;

const convertAttrGroups = (fields, creative) =>
    fields.reduce((acc, { value, label }) => {
        const [topLevelKey, secondLevelKey] = value.split('.');
        const creativeValue = secondLevelKey ? creative[topLevelKey][secondLevelKey] : creative[topLevelKey];

        acc[label] = !creativeValue
            ? UNKNOWN
            : Array.isArray(creativeValue)
            ? arrayCsvValue(creativeValue)
            : `"${creativeValue}"`;
        return acc;
    }, {});

const buildCreativesCsvData = (creatives, creativeTagsByImageHash, selectedCohorts) => {
    return creatives.map(creative => ({
        URL: convertHashToCdnUrl(creative.imageHash),
        ...convertAttrGroups(Object.values(CsvDimensionsMap), creative),
        ...convertAttrGroups(Object.values(MetricsMap), creative.metrics),
        ...convertAttrGroups(selectedCohorts, creative.cohorts),
        ...(creativeTagsByImageHash[creative.imageHash] || {}),
    }));
};

export const aggregateCreativeAIDataByImageHash = creativesTags =>
    creativesTags.reduce((acc, { imageHash, dimensionName, tags }) => {
        acc[imageHash] = acc[imageHash] || {};
        const tagsString = tags.join(', ');
        acc[imageHash][dimensionName] = `${DATE_FORMAT_REGEX.test(tagsString) ? '=' : ''}"${tagsString}"`;
        return acc;
    }, {});

export const downloadCSV = (creativesRawData, creativesTags, app, source, dateRange, selectedCohorts) => {
    const creativeTagsByImageHash = aggregateCreativeAIDataByImageHash(creativesTags);
    const data = buildCreativesCsvData(creativesRawData, creativeTagsByImageHash, selectedCohorts);
    if (!data?.length) return;
    const csvString = [Object.keys(data[0]), ...data.map(item => Object.values(item))]
        .map(row => row.join(','))
        .join('\n');

    // Create a Blob from the CSV string
    const blob = new Blob(['\ufeff', csvString], { type: 'text/csv;charset=utf-8' });

    // Generate a download link and initiate the download
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = buildFileName(app, source, dateRange);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
